import type { SVGProps } from 'react';

const SvgShareLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <circle cx={6} cy={12} r={3} stroke='currentColor' />
    <circle cx={18} cy={6} r={3} stroke='currentColor' />
    <circle cx={18} cy={18} r={3} stroke='currentColor' />
    <path d='M8.5 10L15 7' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M9 14L15 17' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgShareLt;
